import script from "./AppHeaderSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeaderSettings.vue?vue&type=script&setup=true&lang=js"

import "./AppHeaderSettings.vue?vue&type=style&index=0&id=383d67f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-383d67f4"]])

export default __exports__